'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'diamond';
var width = 512;
var height = 512;
var aliases = [9830];
var unicode = 'f219';
var svgPathData = 'M0 256l22.6 22.6L233.4 489.4 256 512l22.6-22.6L489.4 278.6 512 256l-22.6-22.6L278.6 22.6 256 0 233.4 22.6 22.6 233.4 0 256zM256 466.7L45.3 256 256 45.3 466.7 256 256 466.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDiamond = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;